var map = {
	"./aparthotelclub/default_general.png": 37341,
	"./beachful/default_general.png": 81537,
	"./castlepedia/default_general.png": 52947,
	"./cocktayl/default_general.png": 68941,
	"./default_general.png": 92119,
	"./luxresortclub/default_general.png": 33473,
	"./parkful/default_general.png": 21409,
	"./prefabworld/default_general.png": 98936,
	"./rooftopclub/default_general.png": 17769,
	"./spaclub/default_general.png": 40836,
	"./worldcasino/default_general.png": 26329,
	"./zoopedia/default_general.png": 65591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75886;